<template>
  <div>
    <div class="container">
      <div style="margin-bottom: 20px">
        <el-button type="primary" icon="el-icon-plus" @click="AddType"
          >添加分组</el-button
        >
      </div>
      <div style="border: solid 1px #c9cbd6">
        <el-table
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%; min-width: 1000px"
          :header-cell-style="{ background: '#F5F5F5' }"
        >
          <el-table-column
            label="商品分组名称"
            prop="group_name"
          ></el-table-column>

          <el-table-column label="排序">
            <template slot-scope="scope">
              <el-button
                @click="updateSort(scope.$index, 1)"
                size="medium"
                type="text"
                icon="el-icon-upload2"
                style="font-size: 20px"
              ></el-button>

              <el-button
                @click="updateSort(scope.$index, 2)"
                size="medium"
                type="text"
                icon="el-icon-download"
                style="font-size: 20px"
              ></el-button>

              <el-button
                @click="updateSort(scope.$index, 3)"
                size="medium"
                type="text"
                icon="el-icon-top"
                style="font-size: 20px"
              ></el-button>
              <el-button
                @click="updateSort(scope.$index, 4)"
                size="medium"
                type="text"
                icon="el-icon-bottom"
                style="font-size: 20px"
              ></el-button>
            </template>
          </el-table-column>

          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button
                @click="editGroup(scope.row.group_id, scope.row.group_name)"
                type="text"
                size="medium"
                >修改</el-button
              >
              <el-button
                @click="delGroup(scope.row.group_id)"
                type="text"
                size="medium"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>
<script>
import healthmall from "../../../api/healthmall";

export default {
  data() {
    return {
      detail: {},
      edit: false,
      tableData: [],
    };
  },

  methods: {
    //获取健康商城商品类型列表
    getList() {
      healthmall.getGoodsGroupList().then((res) => {
        if (res.code == 0) {
          this.tableData = res.data.list.slice(0, -1);
        }
      });
    },
    //排序
    updateSort(index, status) {
      let data = this.tableData[index];
      this.tableData.splice(index, 1);
      //置顶
      if (status == 1) {
        this.tableData.splice(0, 0, data);
      }
      //置底
      if (status == 2) {
        this.tableData.push(data);
      }
      //上移
      if (status == 3) {
        this.tableData.splice(index - 1, 0, data);
      }
      //下移
      if (status == 4) {
        this.tableData.splice(index + 1, 0, data);
      }
      let list = [];
      list = this.tableData.map((item) => {
        item = _.pick(item, ["group_id", "sort"]);
        return item;
      });
      healthmall.editGoodsGroupSort({ list }).then((res) => {
        if (res.code == 0) {
          this.getList();
        }
      });
    },
    //添加分组
    AddType() {
      this.$prompt("商品分组名称", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /^.{1,10}$/,
        inputPlaceholder: "10个字以内",
        inputErrorMessage: "10个字以内",
        closeOnClickModal: false,
      }).then(({ value }) => {
        let data = {
          group_id: 0,
          group_name: value,
        };
        healthmall.saveGoodsGroupInfo(data).then((res) => {
          if (res.code == 0) {
            this.$message.success("添加成功");
            this.getList();
          }
        });
      });
    },
    //删除分组
    delGroup(group_id) {
      this.$confirm(
        "删除分组后，分组中商品将置为未分组，是否继续？",
        "提示消息",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
        }
      ).then(() => {
        healthmall.deleteGoodsGroupInfo({ group_id }).then((res) => {
          if (res.code == 0) {
            this.$message.success("删除成功");
            this.getList();
          }
        });
      });
    },
    //修改分组
    editGroup(group_id, group_name) {
      this.$prompt("商品分组名称", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /^[\u4e00-\u9fa5]{1,10}$/,
        inputPlaceholder: group_name,
        inputErrorMessage: "分组格式不正确",
        closeOnClickModal: false,
      }).then(({ value }) => {
        let data = {
          group_id: group_id,
          group_name: value,
        };
        healthmall.saveGoodsGroupInfo(data).then((res) => {
          if (res.code == 0) {
            this.$message.success("修改成功");
            this.getList();
          }
        });
      });
    },
  },
  created() {
    this.getList();
  },
};
</script>

<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  padding: 20px;
  text-align: left;
}
</style>

